import React, { useState } from "react";
import styles from "./FAQ.module.scss";

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      question: "What exactly is Vertik.ai?",
      answer:
        "Vertik.ai is your always-on, role-aware AI sales companion — built to connect your sales stack, automate the busywork, and guide every next step from lead to closure.",
    },
    {
      question: "How does Vertik.ai work?",
      answer:
        "We integrate with your existing tools — email, CRM, meetings, calendars, and outreach platforms — then use AI to proactively plan, execute, and track tasks so nothing slips through the cracks.",
    },
    {
      question: "Is Vertik.ai available now?",
      answer:
        "We're currently in private beta with select sales teams. You can join our Early Access list to be among the first to try it when we launch.",
    },
    {
      question: "Will I need to change my CRM or tools?",
      answer:
        "No. Vertik.ai works with what you already use, including Salesforce, HubSpot, Microsoft Dynamics, Gmail, Outlook, Zoom, Google Meet, Teams, and more — all in a single, connected workspace.",
    },
    {
      question: "What kind of tasks can Vertik.ai handle?",
      answer:
        "From logging activities, prepping meetings, and generating follow-ups to managing outreach sequences and surfacing the next best action — we take care of the repetitive work so you can focus on selling.",
    },
    {
      question: "Who is Vertik.ai built for?",
      answer:
        "Modern B2B sales teams — SDRs, AEs, and managers who want a single control center to manage their entire sales workflow without tool-switching.",
    },
    {
      question: "How can I stay updated?",
      answer:
        "Sign up for Early Access and we'll keep you posted with launch updates, feature previews, and exclusive beta invites.",
    },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <section id="faq" className={styles.FAQContainer}>
      <div className="container-custom">
        <div className={styles.FaqHeading}>FAQ</div>
        <div className="flex justify-center items-center w-full">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-8 md:w-10 lg:w-12 h-auto"
            viewBox="0 0 34 2"
            fill="none"
          >
            <path
              d="M1 1H33"
              stroke="url(#paint0_linear_4077_8241)"
              strokeLinecap="round"
            />
            <defs>
              <linearGradient
                id="paint0_linear_4077_8241"
                x1="1"
                y1="2"
                x2="33"
                y2="2"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#80E5FF" />
                <stop offset="1" stopColor="#7584D6" />
              </linearGradient>
            </defs>
          </svg>
        </div>
        <div className="text-center mb-16">
          <h2
            className={`text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-6 ${styles.faqHead}`}
          >
            Burning Questions About Vertik AI
          </h2>
          <p
            className={`text-lg text-gray-600 max-w-3xl mx-auto ${styles.faqHeadDetail}`}
          >
            Simple answers to make things clear.
          </p>
        </div>

        <div className="max-w-[88rem] mx-auto sm:p-6 md:p-8">
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div key={index} className={styles.glassCard}>
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full px-6 pt-4 text-left flex  justify-between items-center  transition-colors"
                >
                  <h3 className={styles.faqQuestion}>{faq.question}</h3>
                  <span
                    className={` pb-4 material-icons text-gray-500 items-center transition-transform duration-300 ${
                      openIndex === index ? "scale-110" : "scale-100"
                    }`}
                  >
                    {openIndex === index ? "-" : "+"}
                  </span>
                </button>

                <div
                  className={`px-6 pb-4 overflow-hidden origin-top transition-all duration-300 ${
                    openIndex === index
                      ? "max-h-[500px] opacity-100 animate-accordion-down"
                      : "max-h-0 opacity-0"
                  }`}
                >
                  <p className={styles.faqAnswer}>{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
